import type { AccountType } from "@/types/api";

export function canReviewAllFlights(
  accountType: AccountType | null | undefined,
): boolean {
  return accountType === "instructor" || accountType === "admin";
}

export function isAdminAccount(
  accountType: AccountType | null | undefined,
): boolean {
  return accountType === "admin";
}

export function formatAccountTypeLabel(
  accountType: AccountType | string | null | undefined,
): string {
  if (accountType === "admin") return "Admin";
  if (accountType === "instructor") return "Instructor";
  return "Pilot";
}
